export const TOOL_TASK = 'remove-from-account-team';
export const TOOL_TITLE = 'Remove From Account Team';
export const TOOL_PROGRESS_LABEL = 'Bulk removing from account team progress...';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once removing user from account team finishes';
export const FILE_NAME = 'Remove-from-account-team-report';
export const FILE_HEADERS = {
    accountId: 'Account ID',
    accountName: 'Account Name',
    managerId: 'Team Member ID',
    managerEmail: 'Team Member Email',
    actionStatus: 'Action Status',
    affectedRelations: 'Affected Team Members',
};
